// extracted by mini-css-extract-plugin
export default {"PasswordIcon":"SocialSecurity_PasswordIcon__mg95q"};